import styled from '@emotion/styled'

import theme from 'styles/theme'

export const VideoThumbnailWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  overflow: hidden;

  position: relative;

  border-radius: ${theme.token.var('borderRadius.small')};
  background: ${theme.token.var('colors.white')};
  cursor: pointer;
`

export const VideoThumbnailImg = styled.img`
  width: 150%;
  height: 150%;
  margin: 0;

  object-fit: cover;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`

export const VideoThumbnailPlayButton = styled.img`
  width: 36px;
  height: 36px;

  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  object-fit: cover;
  pointer-events: none;
`
